import {Injectable, ComponentFactoryResolver, Injector, ApplicationRef, ComponentRef} from '@angular/core';
import {HttpClientService, SuggestionService} from 'inet-core';
import {xCalendar} from "./utils/xCalendar";
import {CalEvent} from "./utils/model/CalEvent";
import * as moment_ from "moment";
import {Observable, Subject} from "rxjs";
import {TaskStatus, TaskTracker} from "./utils/model/task";

const moment = moment_;
declare let iNet: any;
moment.locale('vi');

@Injectable()
export class CalendarService {
  myOrg = {
    organId: iNet.organId,
    orgName: iNet.orgName,
    firmPrefix: iNet.firmPrefix
  };
  locationKeySuggestion = 'xcalendar_location';

  private _ready?: boolean;
  private _fns: Function[] = [];
  private eventChangeSource = new Subject<any>();
  // Observable any stream
  eventChange$ = this.eventChangeSource.asObservable();
  private url = {
    list: iNet.getPUrl('atlas/redmine/tasks'),
    list_attribute: iNet.getPUrl('atlas/redmine/attribute'),

  };
  constructor(
    private http: HttpClientService,
    private suggestService: SuggestionService,
    private componentFactoryResolver: ComponentFactoryResolver,
    private injector: Injector,
    private appRef: ApplicationRef
  ) {
    xCalendar.roleUrl = 'unicorn/page/calendar/role';
    xCalendar.setOrgId(this.myOrg.organId);
    xCalendar.ready(() => {
      xCalendar.loadRole(this.myOrg.organId, (role: any) => {
        xCalendar.setOrgId(this.myOrg.organId);
        this._ready = true;
        this._triggerReady();
      });
    });
  }
  findAll(params: any = {}): Observable<any> {
    this.http.showLoading();
    return this.http.postJSON(this.url.list, params);
  }
  ready(callback: Function) {
    if (this._ready) {
      callback();
    } else {
      this._fns.push(callback);
    }
  }

  private _triggerReady() {
    this._fns.forEach(fn => fn());
    this._fns = [];
  }

  searchLocation(content: string, callback: Function) {
    if (!content) {
      return;
    }
    let params = {
      keyword: this.locationKeySuggestion,
      content: content
    };
    this.suggestService.loadSuggestion(params, callback);
  }

  saveLocation(content: string, callback: Function) {
    if (!content) {
      return;
    }
    let params = {
      keyword: this.locationKeySuggestion,
      content: content
    };
    this.suggestService.saveSuggestion(params, callback);
  }

  createEvent(params: any, callback: Function) {
    this.ready(() => xCalendar.create(params, callback));
  }

  updateEvent(params: any, callback: Function) {
    this.ready(() => xCalendar.update(params, callback));
  }

  removeEvent(params: any, callback: Function) {
    this.ready(() => xCalendar.remove(params, callback));
  }

  attendeeSearch(params: any, callback: Function) {
    this.ready(() => xCalendar.loadUserByKeyword(params, callback));
  }

  loadAttendees( callback: Function) {
    this.ready(() => xCalendar.searchAttendee({}, callback));
  }

  loadEvents(params: any, callback: Function) {
    this.ready(() => xCalendar.getListEvents(params, callback));
  }

  loadMonthEvents(date: any, callback: Function) {
    this.ready(() => xCalendar.loadMonthEvents({}, date, callback));
  }

  loadEvent(params: any, callback: Function) {
    this.ready(() => xCalendar.loadEvent(params, callback));
  }

  deleteAttachment(params: any, callback: Function) {
    this.ready(() => xCalendar.deleteAttachment(params, callback));
  }

  changeEventCalender(eventData: any) {
    this.eventChangeSource.next(eventData);
  }

  viewEvent(event: CalEvent, jsEvent: MouseEvent, target: HTMLElement, onChange: Function) {
    this.changeEventCalender(event.uuid);
  }

  hideViewModal() {

  }
  getClassByTracker(tracker: any): string {
    switch (tracker?.name || tracker) {
      case TaskTracker.BUG.valueOf():
        return 'badge-warning';
      case TaskTracker.FEATURE.valueOf():
        return 'badge-success';
      case TaskTracker.SUPPORT.valueOf():
        return 'badge-primary';
      case TaskTracker.TICKET.valueOf():
        return 'badge-info';
    }
    return 'badge-light';
  }
  getClassByStatusName(statusName: string): string {
    switch (statusName) {
      case TaskStatus.NEW.valueOf():
        return 'badge-info';
      case TaskStatus.IN_PROGRESS.valueOf():
        return 'badge-primary';
      case TaskStatus.RESOLVED.valueOf():
        return 'badge-success';
      case TaskStatus.REJECTED.valueOf():
        return 'badge-warning';
    }
    return 'badge-light';
  }
  listAttributes(): Observable<any> {
    return this.http.postJSON(this.url.list_attribute, );
  }

}
